/**
 * Alexforbes Investment Solutions — brand tokens (AF Connect palette)
 */
export const alexforbesBrand = {
  name: 'Investment Solutions',
  tagline: 'by Alexforbes',
  productName: 'AF Investment Solutions',
  logoPath: '/images/alexforbes-investment-solutions.svg',
  logoMarkPath: '/images/alexforbes-mark.svg',
  logoAlt: 'Investment Solutions by Alexforbes',
  colors: {
    teal: '#007A7A',
    tealLight: '#00A3A3',
    tealDark: '#005C5C',
    orange: '#FF6600',
    orangeLight: '#FF8533',
    orangeDark: '#CC5200',
    black: '#000000',
    greyDark: '#4D4D4D',
    greyMedium: '#808080',
    greyLight: '#D3D3D3',
    background: '#F4F6F8',
    surface: '#FFFFFF',
    sidebar: '#003D3D',
    sidebarDark: '#0D1F1F',
    error: '#c62828',
    neutral: '#8c8c8c',
  },
};

/** Push brand colors into CSS variables (tables, menus, Ant overrides). */
export function applyAlexforbesCssVariables() {
  const c = alexforbesBrand.colors;
  const root = document.documentElement;
  root.style.setProperty('--primary-color', c.teal);
  root.style.setProperty('--primary-hover', c.tealLight);
  root.style.setProperty('--primary-active', c.tealDark);
  root.style.setProperty('--accent-orange', c.orange);
  root.style.setProperty('--accent-orange-hover', c.orangeLight);
  root.style.setProperty('--accent-orange-active', c.orangeDark);
  root.style.setProperty('--btn-primary-color', c.orange);
  root.style.setProperty('--btn-primary-hover', c.orangeLight);
  root.style.setProperty('--btn-primary-active', c.orangeDark);
  root.style.setProperty('--header-bg-color', c.teal);
  root.style.setProperty('--sidebar-bg-color', c.sidebar);
  root.style.setProperty('--af-background', c.background);
}

export const alexforbesAntTheme = {
  light: {
    colorPrimary: alexforbesBrand.colors.orange,
    colorLink: alexforbesBrand.colors.teal,
    colorBgContainer: alexforbesBrand.colors.surface,
    colorBgLayout: alexforbesBrand.colors.background,
    colorText: '#1A1A1A',
    colorTextSecondary: alexforbesBrand.colors.greyMedium,
    borderRadius: 6,
  },
  dark: {
    colorPrimary: alexforbesBrand.colors.orange,
    colorLink: alexforbesBrand.colors.orangeLight,
    colorBgContainer: '#1A2226',
    colorBgLayout: '#0D1114',
    colorText: '#F0F2F5',
    colorTextSecondary: alexforbesBrand.colors.greyLight,
    borderRadius: 6,
  },
};
